/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import { Locale, LocaleKeys } from '../../../core/locale';
import { ScreenTaskControllerTypes } from '../../../core/navigation';
import { TOverlayOptions } from '../../../core/types';
import { showOverlayDialog } from '../../overlaydialog/overlaydialog.reducers';
import { IOverlayDialog } from '../../overlaydialog/overlaydialogprops';
import { setScreenTaskController } from '../../screens/screens.reducers';

export const GLOBAL_MOUSE_TRAP = 'HideGotoOverlay';

export const showGoToOverlay =
    (isSeason: boolean, seasonsOrYears: string[]) => (dispatch: Function) => {
        const itemText = isSeason
            ? Locale.getString(LocaleKeys.SEASON)
            : Locale.getString(LocaleKeys.YEAR);
        const overlapOptions: TOverlayOptions[] = seasonsOrYears.map((seasonOrYear) => {
            return {
                text: `${itemText} ${seasonOrYear}`,
                value: seasonOrYear,
            };
        });
        const overlayProps: IOverlayDialog = {
            hasDimmer: true,
            hasSeperator: false,
            mouseTrapValue: GLOBAL_MOUSE_TRAP,
            options: overlapOptions,
            title: Locale.getString(LocaleKeys.GO_TO_OVERLAY_TITLE),
        };
        dispatch(setScreenTaskController(ScreenTaskControllerTypes.GO_TO_OVERLAY_TASKS));
        dispatch(showOverlayDialog(overlayProps));
    };
